import React from 'react'
import moment from 'moment'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'

const DateFormatTypes = {
  DateOnly: 'l',
  TimeOnly: 'LT',
  DateAndTime: 'M/D/YYYY h:mm a',
  MonthYear: 'MMM-YYYY'
}

function FormatValue (formatType, SessionAccount, value, fixTimeZone) {
  let date = value
  if (!moment.isMoment(value)) {
    if (fixTimeZone) {
      date = moment.tz(value, SessionAccount.TimeZoneId)
    } else {
      date = moment.tz(value, 'UTC')
    }
  }
  if (date.isValid() === false) {
    return 'No Set'
  } else {
    return date.format(formatType)
  }
}

class DateFormatterPlain extends React.Component {
  static propTypes = buildPropTypes([
    sh.SessionAccount
  ], {
    formatType: pt.string,
    fixTimeZone: pt.bool
  })

  static defaultProps = {
    formatType: DateFormatTypes.DateOnly,
    fixTimeZone: false
  }

  render () {
    const { formatType, SessionAccount, value, fixTimeZone } = this.props
    return FormatValue(formatType, SessionAccount, value, fixTimeZone)
  }
}

export const DateFormatter = compose(
  ReduxWrapper([
    sh.SessionAccount
  ])
)(DateFormatterPlain)

DateFormatter.FormatTypes = DateFormatTypes
DateFormatter.Format = FormatValue
